export function renderAppShellView(version: string): string {
  return `
    <a class="skip-link" href="#main">Skip to content</a>
    <header class="app-header">
      <a class="brand" href="#/" aria-label="LineByLine home"><span class="brand__mark">L<span>/</span>L</span><span>LineByLine</span></a>
      <nav aria-label="Primary"><a href="#/">Library</a><a href="#/settings">Settings</a><a href="#/help">Help</a><a class="button button--small" href="#/import" aria-label="Import script">Import<span class="nav-import-detail"> script</span></a></nav>
    </header>
    <main id="main" tabindex="-1"></main>
    <footer class="app-footer"><span>Local-first. Your scripts stay on this device.</span><div class="app-footer__actions"><span>v${version}</span><button class="link-button" data-install hidden>Install app</button></div></footer>`;
}
